export default function shortenString(string: string | null, charNumber: number | undefined = 8) {
  if (!string) {
    return '';
  }

  if (string.length <= charNumber) {
    return string;
  }

  // 针对交易哈希使用前12位
  if (string.startsWith('0x') && string.length === 66) {
    return string.slice(0, 12) + '...';
  }
  // 针对地址保持前6位和后5位
  return string.slice(0, 6) + '...' + string.slice(-5);
}
